<template>
    <VField
        v-slot="{errors, valid, touched, field}"
        :model-value="modelValue"
        :mode="mode"
        :rules="rules"
        :label="(label || name || generatedVid)"
        :name="(parentUuid ? parentUuid + '.' : '') + (name || generatedVid)"
        :immediate="immediate"
        :vid="vid">
        <input
            v-bind="field"
            :class="[generatedVid, (parentUuid ? parentUuid + '.' : '') + (name || generatedVid)]"
            class="d-none">
        <slot
            :errors="errors"
            :valid="valid"
            :invalid="!valid"
            :validated="touched" />
        <div
            v-if="errors[0] && !hideErrors"
            class="invalid-feedback"
            :class="vid"
            style="display: block;">
            {{ errors[0] }}
        </div>
    </VField>
</template>
<script>
import symbols from "@core/app/util/symbols";

import {v4 as uuidv4} from "uuid";

export default {
    name: 'QuickValidator',
    inject: {parentUuid: {from: symbols.nestingFormKey, default: null}},
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String
        },
        rules: {
            type: Object,
            required: true
        },
        modelValue: {
            required: true
        },
        mode: {
            default: 'eager'
        },
        immediate: {
            type: Boolean,
            default: false
        },
        hideErrors: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            uid: uuidv4()
        }
    },
    computed: {
        vid() {
            return (this.$route.name + ':' + this.name + (this.uid || '')).replace(/\s+/g, '_')
        },
        generatedVid() {
            if (this.vid) return this.vid
            return (this.$route.name + ':' + this.name + (this.uid || '')).replace(/\s+/g, '_')
        }
    }
}
</script>
<style lang="scss" scoped>
@use "sass:map";

@mixin smallPadding() {
}

@media (max-width: map.get($grid-breakpoints, 'lg')) {
    @include smallPadding()
}
</style>
